import { useEffect, useState } from "react";
import Hearder from "../commun/Hearder";
import SideBar from "../commun/SideBar";
import swal from "sweetalert";
import Select from "react-select";
import {
    getagentlist,
    getCorporatedetail,
    PropertyRateCode,
    PropertyRateCodeDelete,
    PropertySaveRatecode,
    RateCodeTypes,
} from "../../Services/Service";

export const RateCode = () => {
    const [loading, setLoading] = useState(false);
    const [ratecode, setRatecode] = useState([]);
    const [rateCodes, setRateCodes] = useState([]);
    const [agentList, setAgentList] = useState([]);
    const [corporateList, setCorporateList] = useState([]);

    // Filter form states
    const [filterRateCode, setFilterRateCode] = useState("");
    const [filterAgent, setFilterAgent] = useState("");
    const [filterCorporate, setFilterCorporate] = useState("");
    const [filterCode, setFilterCode] = useState("");
    const [filterName, setFilterName] = useState("");

    // Modal form states
    const [form, setForm] = useState({
        RateCodeID: 0,
        RateCodeTypeID: "",
        AccountID: 0,
        Code: "",
        Name: "",
        Description: "",
        StartDate: "",
        EndDate: "",
    });
    const [selectedCode, setSelectedCode] = useState("");
    const [selectedAgent, setSelectedAgent] = useState("");
    const [selectedCorporate, setSelectedCorporate] = useState("");

    useEffect(() => {
        const fetchRatecode = async () => {
            setLoading(true);
            try {
                const result = await PropertyRateCode();
                if (Array.isArray(result)) setRatecode(result);
            } catch (error) {
                console.log("error get rate code", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRatecode();
    }, []);

    useEffect(() => {
        const fetchRateCodestype = async () => {
            setLoading(true);
            try {
                const res = await RateCodeTypes();
                if (res) setRateCodes(res);
            } catch (error) {
                console.error("Error fetching rate codes:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRateCodestype();
    }, []);

    useEffect(() => {
        const fetchAgentName = async () => {
            setLoading(true);
            try {
                const result = await getagentlist();
                if (Array.isArray(result)) {
                    const filtered = result.filter((a) => a.TA_Name && a.AgentID);
                    setAgentList(filtered);
                }
            } catch (error) {
                console.log("error get Agent Name", error);
            } finally {
                setLoading(false);
            }
        };
        fetchAgentName();
    }, []);

    useEffect(() => {
        const fetchCorporateDetail = async () => {
            setLoading(true);
            try {
                const result = await getCorporatedetail();
                if (Array.isArray(result)) {
                    const filtered = result.filter(
                        (corp) => corp.CorporateID && corp.TA_Name
                    );
                    setCorporateList(filtered);
                }
            } catch (error) {
                console.log("error get corporate detail", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCorporateDetail();
    }, []);

    const handleAdd = () => {
        setForm({
            RateCodeID: 0,
            RateCodeTypeID: "",
            AccountID: 0,
            Code: "",
            Name: "",
            Description: "",
            StartDate: "",
            EndDate: "",
        });
        setSelectedCode("");
        setSelectedAgent("");
        setSelectedCorporate("");
    };

    const handleEdit = (item) => {
        setForm({
            RateCodeID: item.RateCodeID,
            RateCodeTypeID: item.RateCodeTypeID,
            AccountID: item.AccountID,
            Code: item.Code,
            Name: item.Name,
            Description: item.Description,
            StartDate: item.StartDate?.split("T")[0] || "",
            EndDate: item.EndDate?.split("T")[0] || "",
        });

        const type = rateCodes.find((r) => r.ID === item.RateCodeTypeID);
        if (type) setSelectedCode(type.RateCodeType);

        if (item.RateCodeType === "Travel Agent") setSelectedAgent(item.AccountID);
        if (item.RateCodeType === "Corporate") setSelectedCorporate(item.AccountID);
    };

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const selectedType = rateCodes.find((r) => r.RateCodeType === selectedCode);
            const RateCodeTypeID = selectedType ? selectedType.ID : "";

            let AccountID = 0;
            if (selectedCode === "Travel Agent") AccountID = selectedAgent;
            else if (selectedCode === "Corporate") AccountID = selectedCorporate;

            await PropertySaveRatecode(
                form.RateCodeID,
                RateCodeTypeID,
                AccountID,
                form.Code,
                form.Name,
                form.Description,
                form.StartDate,
                form.EndDate
            );

            // setRatecode((prev) => [savedItem, ...prev]);

            const result = await PropertyRateCode();
            if (Array.isArray(result)) setRatecode(result);

            swal("Rate code saved successfully", {
                icon: "success",
                buttons: { confirm: { text: "OK", className: "btn btn-success" } },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("example-modal-lg")
                );
                if (modal) modal.hide();

                setForm({
                    RateCodeID: 0,
                    RateCodeTypeID: "",
                    AccountID: 0,
                    Code: "",
                    Name: "",
                    Description: "",
                    StartDate: "",
                    EndDate: "",
                });
                setSelectedCode("");
                setSelectedAgent("");
                setSelectedCorporate("");
            });
        } catch (error) {
            console.log("error save rate code", error);
            swal("Failed to save rate code!", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (RateCodeID) => {
        try {
            const confirm = await swal({
                title: "Are you sure?",
                icon: "warning",
                buttons: {
                    cancel: "Cancel",
                    confirm: { text: "Delete", value: true, visible: true, className: "btn-danger", closeModal: true },
                },
                dangerMode: true,
            });

            if (confirm) {
                await PropertyRateCodeDelete(RateCodeID);
                setRatecode((prev) => prev.filter((item) => item.RateCodeID !== RateCodeID));
                swal("Rate code deleted successfully!", { icon: "success" });
            }
        } catch (error) {
            console.log("Error deleting rate code:", error);
            swal("Failed to delete rate code!", { icon: "error" });
        }
    };

    const displayedData = ratecode.filter((rc) => {
        let match = true;
        if (filterRateCode) match = match && rc.RateCodeType === filterRateCode;
        if (filterRateCode === "Travel Agent" && filterAgent) match = match && rc.AccountID === parseInt(filterAgent);
        if (filterRateCode === "Corporate" && filterCorporate) match = match && rc.AccountID === parseInt(filterCorporate);
        if (filterCode) match = match && rc.Code === filterCode;
        if (filterName) match = match && rc.Name === filterName;
        return match;
    });

    return (
        <>
            <style>{`.btn_padding { padding: 7px 13px !important; }`}</style>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x" role="status"></div>
                </div>
            )}
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">
                            {/* Filter Form */}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                             <div className="d-flex justify-content-between align-items-center">
                                                 <h4 className="card-title">Rate Code List</h4>
                                                    <button type="button" className="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#example-modal-lg" onClick={handleAdd}>
                                                        Add
                                                    </button>
                                                </div>
                                           
                                        </div>
                                        <div className="card-body">
                                            <form className="mb-0">
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        <div className="input-block">
                                                            <label>Rate code</label>
                                                            <Select
                                                                placeholder="Select Code"
                                                                isClearable
                                                                isSearchable
                                                                value={filterRateCode ? { value: filterRateCode, label: filterRateCode } : null}
                                                                onChange={(option) => setFilterRateCode(option ? option.value : "")}
                                                                options={rateCodes.map((rc) => ({ value: rc.RateCodeType, label: rc.RateCodeType }))}
                                                            />
                                                        </div>
                                                    </div>
                                                    {filterRateCode === "Travel Agent" && (
                                                        <div className="col-sm-3">
                                                            <div className="input-block">
                                                                <label>Travel Agent</label>
                                                                <Select
                                                                    classNamePrefix="select"
                                                                    placeholder="Select or search agent"
                                                                    isClearable
                                                                    isSearchable
                                                                    value={
                                                                        filterAgent
                                                                            ? {
                                                                                value: filterAgent,
                                                                                label: agentList.find((a) => String(a.AgentID) === String(filterAgent))?.TA_Name || "",
                                                                            }
                                                                            : null
                                                                    }
                                                                    onChange={(option) => setFilterAgent(option ? option.value : "")}
                                                                    options={agentList.map((agent) => ({ value: agent.AgentID, label: agent.TA_Name }))}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    {filterRateCode === "Corporate" && (
                                                        <div className="col-sm-3">
                                                            <div className="input-block">
                                                                <label>Corporate</label>
                                                                <Select
                                                                    classNamePrefix="select"
                                                                    placeholder="Select or search corporate"
                                                                    isClearable
                                                                    isSearchable
                                                                    value={
                                                                        filterCorporate
                                                                            ? {
                                                                                value: filterCorporate,
                                                                                label: corporateList.find((c) => String(c.CorporateID) === String(filterCorporate))?.TA_Name || "",
                                                                            }
                                                                            : null
                                                                    }
                                                                    onChange={(option) => setFilterCorporate(option ? option.value : "")}
                                                                    options={corporateList.map((corp) => ({ value: corp.CorporateID, label: corp.TA_Name }))}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="col-sm-2">
                                                        <div className="input-block">
                                                            <label>Code</label>
                                                            <Select
                                                                classNamePrefix="select"
                                                                placeholder="Select code"
                                                                isClearable
                                                                isSearchable
                                                                value={filterCode ? { value: filterCode, label: displayedData.find((rc) => rc.Code === filterCode)?.Code || "" } : null}
                                                                onChange={(option) => setFilterCode(option ? option.value : "")}
                                                                options={displayedData.map((rc) => ({ value: rc.Code, label: rc.Code }))}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="input-block">
                                                            <label>Name</label>
                                                            <Select
                                                                classNamePrefix="select"
                                                                placeholder="Select name"
                                                                isClearable
                                                                isSearchable
                                                                value={filterName ? { value: filterName, label: displayedData.find((rc) => rc.Name === filterName)?.Name || "" } : null}
                                                                onChange={(option) => setFilterName(option ? option.value : "")}
                                                                options={displayedData.map((rc) => ({ value: rc.Name, label: rc.Name }))}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="input-block" style={{ marginTop: "21px" }}>
                                                            <button className="btn btn-primary me-2 btn_padding" onClick={(e) => e.preventDefault()}>
                                                                Filter
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn_padding"
                                                                onClick={() => {
                                                                    setFilterRateCode("");
                                                                    setFilterAgent("");
                                                                    setFilterCorporate("");
                                                                    setFilterCode("");
                                                                    setFilterName("");
                                                                }}
                                                            >
                                                                Clear
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Table */}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                               
                                                <table className="display table table-striped table-hover basic-datatables">
                                                    <thead>
                                                        <tr>
                                                            <th>Code</th>
                                                            <th>Name</th>
                                                            <th>Description</th>
                                                            <th>Start Date</th>
                                                            <th>End Date</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {displayedData.length > 0 ? (
                                                            displayedData.map((item) => (
                                                                <tr key={item.RateCodeID}>
                                                                    <td>{item.Code}</td>
                                                                    <td>{item.Name}</td>
                                                                    <td>{item.Description}</td>
                                                                    <td>{new Date(item.StartDate).toLocaleDateString()}</td>
                                                                    <td>{new Date(item.EndDate).toLocaleDateString()}</td>
                                                                    <td>
                                                                        {item.IsActive ? (
                                                                            <span className="badge bg-success">Active</span>
                                                                        ) : (
                                                                            <span className="badge bg-danger">Inactive</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary btn-sm px-2 py-1 me-2"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#example-modal-lg"
                                                                            onClick={() => handleEdit(item)}
                                                                        >
                                                                            <i className="fas fa-edit"></i>
                                                                        </button>
                                                                        <button className="btn btn-danger py-1 px-2 btn-sm" onClick={() => handleDelete(item.RateCodeID)}>
                                                                            <i className="fas fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="7" className="text-center">
                                                                    No Data Found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Modal */}
                            <div className="modal fade" id="example-modal-lg" tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">{form.RateCodeID ? "Edit Rate Code" : "Add Rate Code"}</h5>
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                        </div>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className={selectedCode === "Travel Agent" || selectedCode === "Corporate" ? "col-sm-6" : "col-sm-12"}>
                                                    <div className="mb-3">
                                                        <label className="form-label">Rate code</label>
                                                        <select className="form-control form-select" value={selectedCode} onChange={(e) => setSelectedCode(e.target.value)}>
                                                            <option>Select code</option>
                                                            {rateCodes.map((item, index) => (
                                                                <option key={index} value={item.RateCodeType}>
                                                                    {item.RateCodeType}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {selectedCode === "Travel Agent" && (
                                                    <div className="col-sm-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Travel Agent</label>
                                                            <select className="form-control form-select" value={selectedAgent} onChange={(e) => setSelectedAgent(e.target.value)}>
                                                                <option value="">Select Travel agent</option>
                                                                {agentList.map((agent) => (
                                                                    <option key={agent.AgentID} value={agent.AgentID}>
                                                                        {agent.TA_Name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}

                                                {selectedCode === "Corporate" && (
                                                    <div className="col-sm-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Corporate</label>
                                                            <select className="form-control form-select" value={selectedCorporate} onChange={(e) => setSelectedCorporate(e.target.value)}>
                                                                <option value="">Select Corporate</option>
                                                                {corporateList.map((corp) => (
                                                                    <option key={corp.CorporateID} value={corp.CorporateID}>
                                                                        {corp.TA_Name} (CP_{corp.CorporateCode || "N/A"})
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Code</label>
                                                        <input type="text" className="form-control" placeholder="Enter code" value={form.Code} onChange={(e) => setForm({ ...form, Code: e.target.value })} />
                                                    </div>
                                                </div>

                                                <div className="col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Name</label>
                                                        <input type="text" className="form-control" placeholder="Enter Name" value={form.Name} onChange={(e) => setForm({ ...form, Name: e.target.value })} />
                                                    </div>
                                                </div>

                                                <div className="col-sm-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Description</label>
                                                        <textarea type="text" className="form-control" placeholder="Enter Description" value={form.Description} onChange={(e) => setForm({ ...form, Description: e.target.value })} />
                                                    </div>
                                                </div>

                                                <div className="col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Start date</label>
                                                        <input type="date" className="form-control" value={form.StartDate} onChange={(e) => setForm({ ...form, StartDate: e.target.value })} />
                                                    </div>
                                                </div>

                                                <div className="col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">End date</label>
                                                        <input type="date" className="form-control" value={form.EndDate} onChange={(e) => setForm({ ...form, EndDate: e.target.value })} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button className="btn btn-primary btn-sm" onClick={handleSubmit}>
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Modal */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
